import Link from "next/link";
import './styles/_platform-features.module.scss';

const PlatformFeaturesOverview = ({ data, className }: { data: any; className?: string }) => {
  return (
    <section className={`platform-features-overview ${className || ''}`}>
      <div className="container">
        {/* Header */}
        <div className="d-flex">
          <div className="left-block">
            <h2>{data.heading}</h2>
          </div>
          <div className="right-block">
            <p>{data.description}</p>
          </div>
        </div>

        {/* Works well with */}
        <div className="works-well-with">
          <div className="section-tag">{data.worksWellWithTag}</div>

          <div className="works-flex-card">
            {data.platforms.map((item, index) => {
              const Icon = item.Icon;
              return (
                <div className="work-card" key={index}>
                  <Link href={item.link} className="works-card">
                    <Icon />
                    <p>{item.title}</p>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>

        {/* CTA */}
        <div className="view-more-button">
          <Link href={data.cta.link}>
            <button className="view-more-btn">{data.cta.text}</button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PlatformFeaturesOverview;